"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInfo = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const components_1 = require("./components");
function FileInfo({ image, acceptedFormats, }) {
    const formatsMsg = acceptedFormats.join(', ');
    return ((0, jsx_runtime_1.jsxs)(components_1.Info, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(svg_1.SvgFile, {}), (0, jsx_runtime_1.jsxs)(components_1.InfoContent, Object.assign({ kind: "vertical", spacing: "0rem" }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Link, { children: ["Choose ", image ? 'image' : 'file'] }), " or drag here:"] })), (0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [formatsMsg, ", max 5 MB"] }))] }))] })));
}
exports.FileInfo = FileInfo;
